import { Component, OnInit, AfterViewInit } from '@angular/core';
declare var AOS: any;
@Component({ selector: 'app-hw-cluster', templateUrl: './digital-cluster.component.html', styleUrls: ['./digital-cluster.component.scss'], standalone: false })
export class DigitalClusterComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'specs', label: 'Specs', icon: 'bx-chip' },
    // { id: 'buy', label: 'Buy Now', icon: 'bx-cart' },
  ];
  specs = [
    { label: 'Display', value: '10.25" IPS TFT LCD' },
    { label: 'Resolution', value: '1920 × 720 px' },
    { label: 'OS', value: 'Android 12 Automotive' },
    { label: 'Connectivity', value: '4G LTE + Wi-Fi + BT5 + GPS' },
    { label: 'Interface', value: 'CAN Bus + OBD-II' },
    { label: 'Power', value: '12V DC (direct or OBD)' },
  ];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
